module.exports = __webpack_public_path__ + "assets/d2aeed5b198c88fe38c1e8181ae5d9e4.png";